export function resolveAppMountBase(pathname?: string): string {
  const path = pathname || '/'

  const branchMatch = path.match(/^\/a\/branch\/[^/]+\/[^/]+/)
  if (branchMatch) {
    return branchMatch[0]
  }

  const devMatch = path.match(/^\/a\/dev\/[^/]+/)
  if (devMatch) {
    return devMatch[0]
  }

  const prodMatch = path.match(/^\/a\/(?!dev(?:\/|$)|branch(?:\/|$))[^/]+/)
  if (prodMatch) {
    return prodMatch[0]
  }

  return ''
}

export function resolveApiBase(pathname?: string): string {
  const base = resolveAppMountBase(pathname)
  return base ? `${base}/api` : '/api'
}

export function withMountBase(path: string, pathname?: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  const base = resolveAppMountBase(pathname)
  return base ? `${base}${normalized}` : normalized
}
